import { POST } from 'dealer-sagas/src/consts/methods'
import apiCall from '../apiCall'
import track from '../track'
interface CreateBetParams {
  offerId: number
  betValue: number
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const createBet = async ({ offerId, betValue }: CreateBetParams): Promise<any> => {
  const endpoint = '/api/v2/bets'
  const params = { bet: { value: betValue, offer_id: offerId } }
  const response = await apiCall({ endpoint, params, method: POST })
  track('dealer_create_bet')
  track('dealer_meaningful_action')
  return response
}
